import { Address } from 'types/common'
import classNames from 'classnames'

import { SeeMore } from '@elements/see-more'
import { PosterImage } from '@elements/poster-image'
import { FormattedContent } from '@elements/formatted-content'
import { TimePlaceDisplay } from '@components/time-place-display'

export interface EventHeaderProps {
  venueName: string
  venueAddress?: Address
  eventName: string
  eventDate?: string
  eventTimezone?: string
  eventPoster?: string
  description?: string
}

export function EventHeader({
  venueName,
  venueAddress,
  eventName,
  eventDate,
  eventPoster,
  description,
}: EventHeaderProps) {
  return (
    <header className={classNames('@container/event-header relative w-full space-x-4', {})}>
      <div className="relative w-full space-x-4">
        {eventPoster && (
          <div className="absolute left-0 h-full animate-fade-in-left max-w-[68px]">
            <PosterImage alt={eventName} src={eventPoster} />
          </div>
        )}
        <div
          className={classNames(
            'transition-transform flex flex-col items-start justify-between space-y-2',
            {
              'translate-x-[70px]': !!eventPoster,
              'translate-x-0': !eventPoster,
            }
          )}
        >
          <h2
            className={classNames(
              'max-w-full text-lg sm:h-auto font-bold leading-[100% + 4px] line-clamp-2 pt-1 !heading-lg sm:!heading-xl',
              {
                'w-[calc(100%-70px)] h-12': !!eventPoster,
                'w-full': !eventPoster,
              }
            )}
          >
            {eventName}
          </h2>
          {!eventPoster && description && (
            <SeeMore clamp={4} className="text-sm @lg/event-header:text-base" inModal>
              <FormattedContent>{description.replaceAll('\n', '<br />')}</FormattedContent>
            </SeeMore>
          )}
          {venueAddress && eventDate && (
            <TimePlaceDisplay place={venueName} address={venueAddress} dateTime={eventDate} />
          )}
        </div>
      </div>
    </header>
  )
}
